import React from 'react'
import { Divider, Form, Icon, Header } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import RichTextEditor from '../../RichTextEditor'
import Metadata from '../Metadata'
import PermissionsManager from '../../PermissionsManager'

const details = ({obj, language, onChange, status, defaultType}) => {
  return (
    <div>
      <Header as='h3'>Bloc contenu de l'article</Header>
      <Form.Field>
        <Form.Input label='Titre' placeholder="Titre" id="title" value={obj.translations[language.code].title} onChange={(e) => onChange(e, language.code)}/>
      </Form.Field>
      { obj.type && defaultType === obj.type &&
        <Form.Field>
          <Form.Input label='Date de publication' placeholder="Date de publication" id="published_at" value={obj.translations[language.code].published_at} onChange={(e) => onChange(e, language.code)}/>
        </Form.Field>
      }
      { obj.type && defaultType === obj.type &&
        <Form.Field>
          <Form.Input label='Extrait' placeholder="Extrait" id="excerpt" value={obj.translations[language.code].excerpt} onChange={(e) => onChange(e, language.code)}/>
        </Form.Field>
      }
      { obj.type && defaultType === obj.type &&
        <Form.Field>
          <label>Contenu</label>
          <RichTextEditor id='content' value={obj.translations[language.code].content} onChange={(e) => onChange(e, language.code)}/>
        </Form.Field>
      }
      <Form.Field>
        <Form.Input label='Tags' placeholder="Tags" id="tags" value={obj.translations[language.code].tags} onChange={(e) => onChange(e, language.code)}/>
      </Form.Field>
      { obj.type && defaultType === obj.type &&
        <Metadata obj={obj} language={language} onChange={onChange}/>
      }
      { obj.type && defaultType === obj.type ?
        <React.Fragment>
          { !status.isNew ?
            <PermissionsManager hasPermissions={['create_article']}>
              <br/>
              <Link to={`/blog/articles/${obj.id}/links/${obj.translations[language.code].id}`} floated='right' className='ui button olive'><Icon name="chain"/> Liens additionnels</Link>
            </PermissionsManager>
            :
            <div><Divider hidden={true} />L'accès aux liens additionnels sera disponible une fois l'élément enregistré</div>
          }
        </React.Fragment>
        :
        null
      }
    </div>
  )
}

export default details



// WEBPACK FOOTER //
// ./src/components/form/article/details.js